export const addDotButtonAndClickHandlers = (emblaApi, dotsNode) => {

  let dotNodes = []

  const addDotBtnsWithClickHandlers = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => '<button class="embla__dot" type="button"></button>')
      .join("")

    const scrollTo = index => emblaApi.scrollTo(index)

    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"))
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener("click", () => scrollTo(index), false)
    })
  }

  const toggleDotButtonsActive = () => {
    const previous = emblaApi.previousScrollSnap()
    const selected = emblaApi.selectedScrollSnap()
    dotNodes[previous].classList.remove("embla__dot--selected")
    dotNodes[selected].classList.add("embla__dot--selected")
  }

  emblaApi
    .on("init", addDotBtnsWithClickHandlers)
    .on("init", toggleDotButtonsActive)
    .on("reInit", addDotBtnsWithClickHandlers) // 👈 capital I
    .on("reInit", toggleDotButtonsActive) // 👈 capital I
    .on("select", toggleDotButtonsActive)
}
